import Vue from 'vue'
import {ebus} from './ebus';
import {parseTableOrNull} from "@/vendor/util";

// let swRegistration = null;
// export function setSwReg(reg) {
//     this.swRegistration = reg;
// }
// export function getSwReg(reg) {
//     return this.swRegistration;
// }

// let tableNumber = 0;
// let tableCreatedAt = 0;

// export function setTable(t) {
//     try {
//         tableNumber = parseInt(t, 10);
//         if (tableNumber < 1) {
//             tableNumber = 0;
//         }
//         tableCreatedAt = Date.now();
//         console.log('table: setTable to ' + tableNumber);
//     } catch (e) {
//         console.log('Error in setTable: ' + e.message);
//     }
// }

// export function getTable() {
//     if ((Date.now() - tableCreatedAt) < (40 * 60 * 1000)) {
//         return tableNumber;
//     } else {
//         tableNumber = 0;
//         tableCreatedAt = 0;
//         return 0;
//     }
// }

function getHash(str, algo = "SHA-256") {
  let strBuf = new TextEncoder('utf-8').encode(str);
  return crypto.subtle.digest(algo, strBuf)
    .then(hash => {
      window.hash = hash;
      // here hash is an arrayBuffer,
      // so we'll connvert it to its hex version
      let result = '';
      const view = new DataView(hash);
      for (let i = 0; i < hash.byteLength; i += 4) {
        result += ('00000000' + view.getUint32(i).toString(16)).slice(-8);
      }
      return result;
    });
}


export async function setSwVersion(fileContent, callb) {
  if (fileContent) {
    try {
      //note: the hash stays the same even after reloading the page if the SW is unchanged
      // let before = new Date().getTime();
      let hash = await getHash(fileContent); // needs 1-3 milliseconds
      // let after = new Date().getTime();
      // console.log('reload hashing time: '+(after-before));
      Vue.ls.set('swVersion', hash);
      callb(hash);
    } catch (e) {
      console.log('Error in setSwVersion: ', e);
      callb(null);
    }
  } else {
    callb(null);
  }
}

export function getSwVersion() {
  return Vue.ls.get('swVersion');
  // if (v) {
  //     return v;
  // } else {
  //     return '';
  // }
}

export function isStandalone() {
  try {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('chrome display-mode is standalone');
      return true;
    }

    if (window.navigator.standalone === true) {
      console.log('safari display-mode is standalone');
      return true;
    }
  } catch (e) {
    console.log('error in isStandalone: ', e);
  }

  // setTimeout(() => {
  //     console.log('??? send installPrompt event now!');
  //     ebus.$emit('installPrompt');
  // }, 3000);

  return false;
}


//*******************************
// PWA
//*******************************
let deferredPrompt;
let userAccepted = false;
// let installed = false;
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('???? native beforeinstallprompt called');
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = e;
  // Update UI notify the user they can add to home screen
//    btnAdd.style.display = 'block';
  console.log('!!!!!!!!!! Send event: beforeinstallprompt');
  if (!userAccepted) {
    ebus.$emit('pwaInstallable');
  } else {
    console.log('!!!!!!!!! Suck the event because user already installed the app');
  }
});

export function isInstallable() {
  return !!deferredPrompt;
}

export function showInstallPrompt() {
  // !isInhouse()
  if (deferredPrompt) {
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          userAccepted = true;
          console.log('!!!!!!!!! User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        deferredPrompt = null;
      });
  } else {
    ebus.$emit('toast', 'This environment does not support the installation of the app. Please use Mircosoft Edge or Chrome Browser.')
  }
}

// export function isInstalled() {
//     return installed;
// }

export function alertInhouse() {
  alert('Hinweis: Wenn Du direkt am Tisch etwas bestellen möchtest, ' +
    'dann verwende bitte jedes Mal den QR-Code auf dem jeweiligen Tisch, um die App zu öffnen.');
  // swUnregister();
}

window.addEventListener('appinstalled', (evt) => {
  console.log('!!!!!!!! a2hs installed');
  // installed = true;
  // if (isInhouse()) {
  //     alertInhouse();
  // } else {
  ebus.$emit('installationCompleted');
  // }
});

let itemsCount = 0;

export function incAndGetItemsCount() {
  return ++itemsCount;
}

export function resetItemsCount() {
  itemsCount = 0;
}

window.addEventListener('online', (evt) => {
  ebus.$emit('appOnline');
});
window.addEventListener('offline', (evt) => {
  ebus.$emit('appOffline');
});


export function hasLocalStorage() {
  try {
    return typeof localStorage !== 'undefined';
  } catch (e) {
    return false;
  }
}

export function getTableFlexState(lsTableFlex) {
  // 1; //has valid tableFlex
  // 2; //no tableFlex
  // 3; //invalid tableFlex
  let query = window.location.search;
  if (query) {
    let params = new URLSearchParams(query);
    let tableFlex = params.get('tableFlex');
    if (tableFlex) {
      //Prüfe Ungültigkeit des Flex codes
      // Wenn query tableFlex vorhanden und tls tableFlex nicht vorhanden
      //     => Bitte QR code scannen
      if (!lsTableFlex) {
        return 3; //invalid tableFlex
      } else {
        return 1; //has valid tableFlex
      }
    }
  }
  return 2; //no tableFlex
}

try {
  const swBus = new BroadcastChannel('swBus');
  swBus.onmessage = (e) => {
    //e.data
    console.log('swBus message received in app: ' + JSON.stringify(e.data));
    let d = e.data;
    if (d) {
      if (d.forwardEmit && d.address) {
        ebus.$emit(d.address, d.params);
      }
    }
  };
} catch (e) {
  console.log('BroadcastChannel not available in window');
}


export function isInhouse() {
  try {
    let inhouse = false;
    let scannedTable = parseTableOrNull(Vue.ls.get('scannedTable'));
    // OnlyforFilialbetriebe
    // let scannedStore = Vue.ls.get('scannedStore');
    // inhouse = (scannedTable && scannedStore) || window.location.hostname.toLowerCase().indexOf('inhouse') !== -1;
    inhouse = (scannedTable) || window.location.hostname.toLowerCase().indexOf('inhouse') !== -1;
    if (!inhouse) {
      let query = window.location.search;
      let params = new URLSearchParams(query);
      let table = parseTableOrNull(params.get('table'));
      // OnlyforFilialbetriebe
      // let storeNumber = params.get('store');
      // if (table && storeNumber) {
      //   inhouse = true;
      // }
      if (table) {
        inhouse = true;
      }
    }
    // console.log('isInhouse = ' + inhouse);
    return inhouse;
  } catch (e) {

  }
  return false;
  // return true;
  // try{
  //     if(isStandalone()){
  //         return false;
  //     }
  //
  //     let query = window.location.search;
  //     let inhouse = false;
  //     if (query) {
  //         try {
  //             let params = new URLSearchParams(query);
  //             let ih = params.get('inhouse');
  //             inhouse = !!ih;
  //         } catch (eQuery) {
  //             console.log('error in eQuery: '+eQuery.message);
  //         }
  //     }
  //     return inhouse;
  // }catch (e) {
  //     console.log('error in isInhouse: '+e.message);
  //     return false;
  // }
  // return window.location.hostname.toLowerCase().indexOf('inhouse') !== -1 //&& !isStandalone();
}


